import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "device",
    "draggableDevice",
    "image",
    "popup",
    "popupContent",
    "editLink",
    "deleteLink",
    "deviceCanvas"
  ]

  connect() {
    this.isShow = false
    this.activeElement = null

    if (this.hasDraggableDeviceTarget && this.hasImageTarget) {
      this.makeDraggable(this.draggableDeviceTarget)
      this.initializeDefaultPosition()
    }

  }

  // Added: handle device type change
  onDeviceTypeChange(event) {
    this.updateDeviceIcon(event.target.id)
  }

  updateDeviceIcon(deviceTypeId) {
    if (!this.hasDraggableDeviceTarget) {
      return
    }

    // Get the corresponding icon name according to device type ID
    const deviceTypeName = this.getDeviceTypeName(deviceTypeId)

    const iconPath = this.getIconPath(deviceTypeName)

    // Update icon src
    this.draggableDeviceTarget.src = iconPath
  }

  getDeviceTypeName(deviceTypeId) {
    // Get device type name from DOM
    const deviceTypeElement = document.getElementById(deviceTypeId)

    if (deviceTypeElement) {
      const dataAttribute = deviceTypeElement.getAttribute('data-device-type-name')
      const textContent = deviceTypeElement.textContent.trim()

      return dataAttribute || textContent
    }
    return null
  }

  getIconPath(deviceTypeName) {
    if (!deviceTypeName) return "/assets/icons/device-placement-ap.svg"

    const normalizedName = deviceTypeName.toLowerCase().replace(/\s+/g, '-')

    switch (normalizedName) {
      case 'access-point':
        return "/assets/icons/device-placement-ap.svg"
      case 'poe-switch':
      case 'switch':
        return "/assets/icons/device-placement-switch.svg"
      case 'gateway':
        return "/assets/icons/device-placement-gateway.svg"
      default:
        return "/assets/icons/device-placement-ap.svg"
    }
  }

  makeDraggable(el) {
    el.addEventListener("mousedown", e => {
      e.preventDefault()
      const containerRect = this.imageTarget.getBoundingClientRect()
      const elRect = el.getBoundingClientRect()

      const shiftX = e.clientX - elRect.left
      const shiftY = e.clientY - elRect.top

      const onMouseMove = (e) => {
        let newX = e.clientX - containerRect.left - shiftX
        let newY = e.clientY - containerRect.top - shiftY

        newX = Math.max(0, Math.min(newX, containerRect.width - el.offsetWidth))
        newY = Math.max(0, Math.min(newY, containerRect.height - el.offsetHeight))

        el.style.left = `${newX}px`
        el.style.top = `${newY}px`
      }

      const onMouseUp = (e) => {
        document.removeEventListener("mousemove", onMouseMove)
        document.removeEventListener("mouseup", onMouseUp)
        this.setFormFields(parseFloat(el.style.left), parseFloat(el.style.top))
      }

      document.addEventListener("mousemove", onMouseMove)
      document.addEventListener("mouseup", onMouseUp)
    })

    el.ondragstart = () => false
  }

  setFormFields(x, y) {
    document.getElementById("position_x").value = x
    document.getElementById("position_y").value = y
  }

  initializeDefaultPosition() {
    const positionX = document.getElementById("position_x").value
    const positionY = document.getElementById("position_y").value

    if (positionX && positionY) {
      this.draggableDeviceTarget.style.left = `${positionX}px`
      this.draggableDeviceTarget.style.top = `${positionY}px`
    }
  }

  onCanvasClick(event) {
    if (this.isShow || !this.hasPopupTarget) { return }
    this.activeElement = event.target
    this.showDeviceInfo(this.activeElement.dataset);
    this.activeElement.classList.add("active")
  }

  showDeviceInfo(device) {
    if (this.hasPopupTarget && this.hasPopupContentTarget) {
      const popup = this.popupTarget;
      const content = this.popupContentTarget;

      content.innerHTML = `
        <span id="popup-device-type" class="text-f1">
          Device Type: <span class="text-p5">${device.deviceType}</span>
        </span>
        <span id="popup-device-model" class="text-f1">
          Device Model: <span class="text-p5">${device.deviceModel}</span>
        </span>
        <span id="popup-placement" class="text-f1">
          Placement: <span class="text-p5">${device.placement}</span>
        </span>
      `;

      const currentPath = window.location.pathname
      this.editLinkTarget.href = `${currentPath}/${device.id}/edit`
      this.deleteLinkTarget.href = `${currentPath}/${device.id}`
      this.deleteLinkTarget.dataset.url = `${currentPath}/${device.id}`

      popup.classList.remove("hidden");
      this.isShow = true
    }
  }

  hidePopup() {
    if (this.hasPopupTarget) {
      this.isShow = false
      this.popupTarget.classList.add("hidden")
      this.activeElement.classList.remove("active")
    }
  }
}
